import type { PaymentSlaState } from '../../api/types';
import styles from './Payments.module.css';
import { slaFormat } from './slaFormat';

export function SlaChip({
  state,
  dueAt,
  now,
}: {
  state: PaymentSlaState;
  dueAt: string | null;
  now?: Date;
}) {
  const tone = state === 'BREACHED' ? 'red' : state === 'AT_RISK' ? 'amber' : 'green';
  return (
    <span
      className={`${styles.statusChip} ${styles[tone]}`}
      data-testid="sla-chip"
      data-tone={tone}
      style={{
        color: `var(--${tone === 'green' ? 'success' : tone === 'amber' ? 'warning' : 'danger'})`,
        fontWeight: 700,
      }}
    >
      {slaFormat(dueAt, now)}
    </span>
  );
}
